import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CREDIT_TYPE } from '../../../framework/App/AppConstants';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import DefaultCTABanner from './DefaultCTABanner/DefaultCTABanner';
import IncentivesCTABanner from './IncentivesCTABanner/IncentivesCTABanner';
import DefaultGreeting from './DefaultGreeting';
import './CTABannerContainer.less';
import { PAGE_NAME } from '../../config/pageNames';

const LOCALE_PREFIX = 'US/components/CTABanner/CTABanner';

export class CTABannerContainer extends Component {

    static propTypes = {
        creditType: PropTypes.oneOf(Object.values(CREDIT_TYPE)).isRequired,
        user: PropTypes.shape({
            firstName: PropTypes.string
        }),
        financingDetails: PropTypes.shape({
            term: PropTypes.number
        }),
        incentivesDetails: PropTypes.shape({
            headline_text: PropTypes.string,
            offer_text_1: PropTypes.string,
            offer_text_2: PropTypes.string,
            terms_link: PropTypes.string,
            terms_link_text: PropTypes.string,
            terms_text: PropTypes.string,
        }),
        pageName: PropTypes.string,

        // Passed in props
        showDefaultGreeting: PropTypes.bool,
        flow: PropTypes.string
    };

    static defaultProps = {
        showDefaultGreeting: true
    };

    getDefaultGreeting() {
        const { showDefaultGreeting, user } = this.props;

        if (showDefaultGreeting) {

            const name = _.get(user, 'firstName');

            const greeting = name ? (
                <FormattedMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-greeting-name`} values={{ name }} />
            ) : (
                <FormattedMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-greeting`} />
            );

            return (<DefaultGreeting greeting={greeting} />);

        } else {
            return '';
        }

    }

    render() {

        const { user, financingDetails, showDefaultGreeting, incentivesDetails, pageName, flow } = this.props;
        let { creditType } = this.props;

        const pageNameClass = pageName ? `CTABannerContainer--${pageName}` : '';
        const greeting = this.getDefaultGreeting();
        const name = _.get(user, 'firstName');

        // Use default banner for Billing Info Page
        if ((pageName === PAGE_NAME.BILLING_PAGE)) {
            creditType = CREDIT_TYPE.DEFAULT;
        }

        let creditLineBanner = (
            <DefaultCTABanner
                creditType={creditType}
                financingDetails={financingDetails}
                name={name}
                showDefaultGreeting={showDefaultGreeting}
                flow={flow}
            />
        );

        if (!_.isEmpty(incentivesDetails)) {
            creditLineBanner = (
                <IncentivesCTABanner
                    creditType={creditType}
                    incentivesDetails={incentivesDetails}
                    name={name}
                    pageName={pageName}
                    showDefaultGreeting={showDefaultGreeting}
                />
            );
        }

        return (
            <div className={`CTABannerContainer ${pageNameClass}`}>
                {creditLineBanner}
                {greeting}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    creditType: _.get(state, 'cycoPage.cycoSelectedOption.credit_type') || _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
    financingDetails: _.get(state, 'cycoPage.cycoSelectedOption') || _.get(state, 'serverData.financingDetails', {}),
    incentivesDetails: _.get(state, 'serverData.incentivesDetails', {}),
    pageName: _.get(state, 'skeletonPage.currentPage'),
    user: _.get(state, 'serverData.user'),
    flow: _.get(state, 'serverData.flow')
});

export default connect(mapStateToProps)(CTABannerContainer);
